import { render, staticRenderFns } from "./RestartSetupSection.vue?vue&type=template&id=15fb0a42&scoped=true&"
import script from "./RestartSetupSection.vue?vue&type=script&lang=ts&"
export * from "./RestartSetupSection.vue?vue&type=script&lang=ts&"
import style0 from "./RestartSetupSection.vue?vue&type=style&index=0&id=15fb0a42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fb0a42",
  null
  
)

export default component.exports